
/*
* Shape sub-type to its resize mixin functions.
* Maybe if statement provides more flexibility ... i don't think I have a 'sub-shape' model/arch ...
* */


var Free = require('./free'),
    Poly = require('./poly/poly'),
    Line = require('./poly/line'),
    LineArrow = require('./poly/lineArrow'),
    FreeNoReflection = require('./freeNoReflection');


var XREF = {

    rect: Free,
    'rect-fill': Free,
    'rect-nofill': Free,
    free: Free,
    text: Free,
    signature: Free,
    text_stamp: Free, // maybe a proportional resize 'free' here
    graphic_stamp: FreeNoReflection,


    poly: Poly,
    line: Line,
    'line-dashed': Line,
    'line-arrow': LineArrow
};


module.exports = function(shapeSubType) {
    return XREF[shapeSubType];
};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/resizeFns/factory.js
 ** module id = 192
 ** module chunks = 0
 **/